import React, {Component} from 'react'
import {connect}          from 'react-redux'
import Splash             from '../containers/Splash'

class Stage extends Component {
  render() {
    return (
      <Splash />
    )
  }
}

function mapStateToProps(state) {
  return {

  }
}

function mapDispatchToProps(dispatch) {
  return {

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Stage)



// WEBPACK FOOTER //
// ./src/containers/Stage.js